import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Typography,
  Switch,
} from "@mui/material";
import Notification from "../../Components/Notification";
import Button from "../../Components/Button/Button";
import CompletionTick from "../../assets/logo/completionTick.svg";
import BusinessBanking from "../BusinessBanking/BusinessBanking";
import Insurance from "../Insurance/Insurance";
import WebDomain from "../WebDomain/WebDomain";
import WorkEmail from "../WorkEmail/WorkEmail";
import VirtualOfficePage from "../VirtualOfficePage/VirtualOfficePage";
import AccountSoftware from "../AccountingSoftware.js/AccountSoftware";

const CompanySetupLayout = () => {
  const activeForm = localStorage.getItem("activeFormCompanySetup");
  const [openParentItem, setOpenParentItem] = useState("banking");
  const [openChildItem, setOpenChildItem] = useState("banking");
  const [isBankingDetailsCompleted, setIsBankingDetailsCompleted] =
    useState(false);
  const [isInsuranceCompleted, setInsuranceCompleted] = useState(false);
  const [isWebDomainCompleted, setWebDomainCompleted] = useState(false);
  const [isWorkEmailCompleted, setWorkEmailCompleted] = useState(false);
  const [isVirtualOfficeCompleted, setVirtualOfficeCompleted] = useState(false);
  const [isAccountingCompleted, setAccountingCompleted] = useState(false);

  useEffect(() => {
    if (activeForm === "isBankingDetailCompleted") {
      setIsBankingDetailsCompleted(true);
      setOpenParentItem("insurance");
      setOpenChildItem("web_domain");
    } else if (activeForm === "isInsuranceDetailCompleted") {
      setIsBankingDetailsCompleted(true);
      setInsuranceCompleted(true);
      setOpenParentItem("web_domain");
      setOpenChildItem("work_email");
    } else if (activeForm === "isWebsiteDomainCompleted") {
      setIsBankingDetailsCompleted(true);
      setInsuranceCompleted(true);
      setWebDomainCompleted(true);
      setOpenParentItem("work_email");
      setOpenChildItem("virtual_office");
    } else if (activeForm === "isWorkEmailCompleted") {
      setIsBankingDetailsCompleted(true);
      setInsuranceCompleted(true);
      setWebDomainCompleted(true);
      setWorkEmailCompleted(true);
      setOpenParentItem("virtual_office");
      setOpenChildItem("accounting_software");
    } else if (activeForm === "isVirtualOfficeCompleted") {
      setIsBankingDetailsCompleted(true);
      setInsuranceCompleted(true);
      setWebDomainCompleted(true);
      setWorkEmailCompleted(true);
      setVirtualOfficeCompleted(true);
      setOpenParentItem("accounting_software");
      setOpenChildItem("");
    } else if (activeForm === "isFormCompleted") {
      setIsBankingDetailsCompleted(true);
      setInsuranceCompleted(true);
      setWebDomainCompleted(true);
      setWorkEmailCompleted(true);
      setVirtualOfficeCompleted(true);
      setAccountingCompleted(true);
    }
  }, [activeForm]);

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleContinue = (currentParent, nextParent, nextChild) => {
    if (currentParent === "banking") {
      setIsBankingDetailsCompleted(true);
    }
    if (currentParent === "insurance") {
      setInsuranceCompleted(true);
    }
    if (currentParent === "web_domain") {
      setWebDomainCompleted(true);
    }
    if (currentParent === "work_email") {
      setWorkEmailCompleted(true);
    }
    if (currentParent === "virtual_office") {
      setVirtualOfficeCompleted(true);
    }

    setOpenParentItem(nextParent);
    setOpenChildItem(nextChild);
    setNotification({
      open: true,
      message: "Previous form successfully saved!",
      severity: "success",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotification({ ...notification, open: false });
  };

  const handleBack = (prevParent, prevChild) => {
    setOpenParentItem(prevParent);
    setOpenChildItem(prevChild);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      width={"100%"}
      sx={{
        marginTop: "2px",
        height: "calc(100vh - 5.3rem)",
      }}
      display={"flex"}
    >
      <Box
        width={"20%"}
        sx={{
          backgroundColor: "#f3e8ff",
          padding: "2rem 1rem",
          fontWeight: "bold",
        }}
      >
        <Typography
          variant="h5"
          fontWeight="medium"
          color="text.primary"
          sx={{ ml: 4 }}
        >
          Company Setup
        </Typography>
        <List component="nav">
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isBankingDetailsCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button isActive={openParentItem === "banking"} value="1" />
              )}
              <ListItemText
                primary="Business Banking"
                sx={{
                  color:
                    openParentItem === "banking"
                      ? "#3056D3"
                      : isBankingDetailsCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isInsuranceCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button isActive={openParentItem === "insurance"} value="2" />
              )}
              <ListItemText
                primary="Insurance"
                sx={{
                  color:
                    openParentItem === "insurance"
                      ? "#3056D3"
                      : isInsuranceCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isWebDomainCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button isActive={openParentItem === "web_domain"} value="3" />
              )}
              <ListItemText
                primary="Web Domain"
                sx={{
                  color:
                    openParentItem === "web_domain"
                      ? "#3056D3"
                      : isWebDomainCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isWorkEmailCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button isActive={openParentItem === "work_email"} value="4" />
              )}
              <ListItemText
                primary="Work Email"
                sx={{
                  color:
                    openParentItem === "work_email"
                      ? "#3056D3"
                      : isWorkEmailCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isVirtualOfficeCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button
                  isActive={openParentItem === "virtual_office"}
                  value="5"
                />
              )}
              <ListItemText
                primary="Virtual Office"
                sx={{
                  color:
                    openParentItem === "virtual_office"
                      ? "#3056D3"
                      : isVirtualOfficeCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton sx={{ padding: "0.5rem", cursor: "default" }}>
              {isAccountingCompleted ? (
                <Box>
                  <img
                    width={"27px"}
                    style={{ marginRight: "7px" }}
                    src={CompletionTick}
                  />
                </Box>
              ) : (
                <Button
                  isActive={openParentItem === "accounting_software"}
                  value="6"
                />
              )}
              <ListItemText
                primary="Accounting Software"
                sx={{
                  color:
                    openParentItem === "accounting_software"
                      ? "#3056D3"
                      : isAccountingCompleted
                      ? "#3056D3"
                      : "#64748B",
                  marginLeft: "0.25rem",
                  fontSize: "0.875rem !important",
                }}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "medium",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <Box
        width={"100%"}
        // p={3} 
        backgroundColor='#FFF' 
        sx={{
          flexGrow: 1,
          overflowY: "scroll",
        }}
      >
        {openParentItem === "banking" && openChildItem === "banking" && (
          <BusinessBanking
            onContinue={() =>
              handleContinue("banking", "insurance", "web_domain")
            }
          />
        )}
        {openParentItem === "insurance" && openChildItem === "web_domain" && (
          <Insurance
            onContinue={() =>
              handleContinue("insurance", "web_domain", "work_email")
            }
            onBack={() => handleBack("banking", "banking")}
          />
        )}
        {openParentItem === "web_domain" && openChildItem === "work_email" && (
          <WebDomain
            onContinue={() =>
              handleContinue("web_domain", "work_email", "virtual_office")
            }
            onBack={() => handleBack("insurance", "web_domain")}
          />
        )}
        {openParentItem === "work_email" &&
          openChildItem === "virtual_office" && (
            <WorkEmail
              onContinue={() =>
                handleContinue(
                  "work_email",
                  "virtual_office",
                  "accounting_software"
                )
              }
              onBack={() => handleBack("web_domain", "work_email")}
            />
          )}
        {openParentItem === "virtual_office" &&
          openChildItem === "accounting_software" && (
            <VirtualOfficePage
              onContinue={() =>
                handleContinue("virtual_office", "accounting_software", "")
              }
              onBack={() => handleBack("work_email", "virtual_office")}
            />
          )}
        {openParentItem === "accounting_software" && (
          <AccountSoftware
            onBack={() => handleBack("virtual_office", "accounting_software")}
          />
        )}
      </Box>
      <Notification
        open={notification.open}
        message={notification.message}
        onClose={handleCloseNotification}
        severity={notification.severity}
      />
    </Box>
  );
};

export default CompanySetupLayout;
